import { render, staticRenderFns } from "./CategoriesStatistics.vue?vue&type=template&id=69d19347"
import script from "./CategoriesStatistics.vue?vue&type=script&lang=js"
export * from "./CategoriesStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports